// General & Administrative Expenses Data
export const generalAdminData = {
  2024: {
    total: 28.0,
    prevYearTotal: 25.5,
    yoyChange: 9.8,
    // Categoria 1: Serviços de Suporte
    supportServices: {
      total: 9.8,
      prevYear: 8.9,
      yoyChange: 10.1,
      items: [
        { name: { pt: 'Contencioso e Notariado', en: 'Litigation & Notary' }, value: 0.9, prevYear: 0.8 },
        { name: { pt: 'Assistência Técnica', en: 'Technical Assistance' }, value: 1.4, prevYear: 1.3 },
        { name: { pt: 'Avaliação de Diamantes', en: 'Diamond Valuation' }, value: 1.2, prevYear: 1.1 },
        { name: { pt: 'Serviços Técnicos de Engenharia', en: 'Engineering Technical Services' }, value: 1.5, prevYear: 1.35 },
        { name: { pt: 'Auditoria / Consultoria', en: 'Audit / Consulting' }, value: 1.2, prevYear: 1.1 },
        { name: { pt: 'Consultoria Fiscal', en: 'Tax Advisory' }, value: 0.8, prevYear: 0.7 },
        { name: { pt: 'Análises Laboratoriais/Estudos', en: 'Lab Analysis/Studies' }, value: 0.9, prevYear: 0.8 },
        { name: { pt: 'Serviços Jurídicos', en: 'Legal Services' }, value: 0.9, prevYear: 0.85 },
        { name: { pt: 'Honorários e Avenças', en: 'Fees & Retainers' }, value: 0.5, prevYear: 0.45 },
        { name: { pt: 'Planeamento e Optimização de Mina', en: 'Mine Planning & Optimization' }, value: 0.5, prevYear: 0.45 },
      ]
    },
    // Categoria 2: Custos de Estrutura
    structureCosts: {
      total: 10.5,
      prevYear: 9.6,
      yoyChange: 9.4,
      items: [
        { name: { pt: 'Água', en: 'Water' }, value: 0.3, prevYear: 0.28 },
        { name: { pt: 'Electricidade', en: 'Electricity' }, value: 0.8, prevYear: 0.75 },
        { name: { pt: 'Combustíveis e Lubrificantes', en: 'Fuels & Lubricants' }, value: 1.8, prevYear: 1.7 },
        { name: { pt: 'Material Conservação e Reparação', en: 'Maintenance Materials' }, value: 1.2, prevYear: 1.1 },
        { name: { pt: 'Ferramentas e Utensílios', en: 'Tools & Utensils' }, value: 0.6, prevYear: 0.55 },
        { name: { pt: 'Material de Escritório', en: 'Office Supplies' }, value: 0.2, prevYear: 0.18 },
        { name: { pt: 'Rendas de Imóveis', en: 'Property Rentals' }, value: 1.5, prevYear: 1.4 },
        { name: { pt: 'Aluguer de Equipamento', en: 'Equipment Rental' }, value: 0.8, prevYear: 0.75 },
        { name: { pt: 'Transportes', en: 'Transportation' }, value: 1.0, prevYear: 0.9 },
        { name: { pt: 'Deslocações e Estadas', en: 'Travel & Accommodation' }, value: 0.7, prevYear: 0.65 },
        { name: { pt: 'Conservação e Reparação', en: 'Maintenance & Repairs' }, value: 0.8, prevYear: 0.75 },
        { name: { pt: 'Limpeza, Higiene e Conforto', en: 'Cleaning & Hygiene' }, value: 0.4, prevYear: 0.35 },
        { name: { pt: 'Serviços Aduaneiros', en: 'Customs Services' }, value: 0.4, prevYear: 0.35 },
      ]
    },
    // Categoria 3: Segurança, Seguros e Responsabilidade Corporativa
    securityInsurance: {
      total: 4.2,
      prevYear: 3.8,
      yoyChange: 10.5,
      items: [
        { name: { pt: 'Vigilância e Segurança', en: 'Security & Surveillance' }, value: 1.8, prevYear: 1.6 },
        { name: { pt: 'Seguros', en: 'Insurance' }, value: 1.2, prevYear: 1.1 },
        { name: { pt: 'Material de Protecção e Segurança', en: 'Safety & Protection Equipment' }, value: 0.5, prevYear: 0.45 },
        { name: { pt: 'Quotizações (ANPID)', en: 'Memberships (ANPID)' }, value: 0.3, prevYear: 0.28 },
        { name: { pt: 'Estudos Ambientais', en: 'Environmental Studies' }, value: 0.4, prevYear: 0.37 },
      ]
    },
    // Categoria 4: TI, Comunicação e Publicidade
    itCommunication: {
      total: 3.5,
      prevYear: 3.2,
      yoyChange: 9.4,
      items: [
        { name: { pt: 'Licenças Informáticas', en: 'Software Licenses' }, value: 0.8, prevYear: 0.7 },
        { name: { pt: 'Serviços Informáticos', en: 'IT Services' }, value: 0.5, prevYear: 0.45 },
        { name: { pt: 'Suporte ERP e Aplicações', en: 'ERP & Apps Support' }, value: 0.5, prevYear: 0.45 },
        { name: { pt: 'Managed Print Services', en: 'Managed Print Services' }, value: 0.2, prevYear: 0.18 },
        { name: { pt: 'Cibersegurança/NIS2', en: 'Cybersecurity/NIS2' }, value: 0.4, prevYear: 0.35 },
        { name: { pt: 'Comunicações', en: 'Communications' }, value: 0.5, prevYear: 0.5 },
        { name: { pt: 'Publicidade e Propaganda', en: 'Advertising' }, value: 0.3, prevYear: 0.28 },
        { name: { pt: 'IT - Consultoria e Compliance', en: 'IT - Consulting & Compliance' }, value: 0.3, prevYear: 0.29 },
      ]
    },
  },
  2025: {
    total: 35.6,
    prevYearTotal: 28.0,
    yoyChange: 27.1,
    budgetTotal: 34.2,
    vsBudget: 4.1,
    supportServices: {
      total: 12.5,
      prevYear: 9.8,
      yoyChange: 27.6,
      budgetTotal: 12.0,
      vsBudget: 4.2,
      items: [
        { name: { pt: 'Contencioso e Notariado', en: 'Litigation & Notary' }, value: 1.1, prevYear: 0.9, budget: 1.05, vsBudget: 4.8 },
        { name: { pt: 'Assistência Técnica', en: 'Technical Assistance' }, value: 1.8, prevYear: 1.4, budget: 1.72, vsBudget: 4.7 },
        { name: { pt: 'Avaliação de Diamantes', en: 'Diamond Valuation' }, value: 1.5, prevYear: 1.2, budget: 1.45, vsBudget: 3.4 },
        { name: { pt: 'Serviços Técnicos de Engenharia', en: 'Engineering Technical Services' }, value: 2.0, prevYear: 1.5, budget: 1.9, vsBudget: 5.3 },
        { name: { pt: 'Auditoria / Consultoria', en: 'Audit / Consulting' }, value: 1.5, prevYear: 1.2, budget: 1.45, vsBudget: 3.4 },
        { name: { pt: 'Consultoria Fiscal', en: 'Tax Advisory' }, value: 1.0, prevYear: 0.8, budget: 0.95, vsBudget: 5.3 },
        { name: { pt: 'Análises Laboratoriais/Estudos', en: 'Lab Analysis/Studies' }, value: 1.2, prevYear: 0.9, budget: 1.15, vsBudget: 4.3 },
        { name: { pt: 'Serviços Jurídicos', en: 'Legal Services' }, value: 1.2, prevYear: 0.9, budget: 1.18, vsBudget: 1.7 },
        { name: { pt: 'Honorários e Avenças', en: 'Fees & Retainers' }, value: 0.6, prevYear: 0.5, budget: 0.58, vsBudget: 3.4 },
        { name: { pt: 'Planeamento e Optimização de Mina', en: 'Mine Planning & Optimization' }, value: 0.6, prevYear: 0.5, budget: 0.57, vsBudget: 5.3 },
      ]
    },
    structureCosts: {
      total: 13.2,
      prevYear: 10.5,
      yoyChange: 25.7,
      budgetTotal: 12.7,
      vsBudget: 3.9,
      items: [
        { name: { pt: 'Água', en: 'Water' }, value: 0.4, prevYear: 0.3, budget: 0.38, vsBudget: 5.3 },
        { name: { pt: 'Electricidade', en: 'Electricity' }, value: 1.0, prevYear: 0.8, budget: 0.95, vsBudget: 5.3 },
        { name: { pt: 'Combustíveis e Lubrificantes', en: 'Fuels & Lubricants' }, value: 2.3, prevYear: 1.8, budget: 2.2, vsBudget: 4.5 },
        { name: { pt: 'Material Conservação e Reparação', en: 'Maintenance Materials' }, value: 1.5, prevYear: 1.2, budget: 1.45, vsBudget: 3.4 },
        { name: { pt: 'Ferramentas e Utensílios', en: 'Tools & Utensils' }, value: 0.8, prevYear: 0.6, budget: 0.77, vsBudget: 3.9 },
        { name: { pt: 'Material de Escritório', en: 'Office Supplies' }, value: 0.3, prevYear: 0.2, budget: 0.29, vsBudget: 3.4 },
        { name: { pt: 'Rendas de Imóveis', en: 'Property Rentals' }, value: 1.9, prevYear: 1.5, budget: 1.85, vsBudget: 2.7 },
        { name: { pt: 'Aluguer de Equipamento', en: 'Equipment Rental' }, value: 1.0, prevYear: 0.8, budget: 0.95, vsBudget: 5.3 },
        { name: { pt: 'Transportes', en: 'Transportation' }, value: 1.3, prevYear: 1.0, budget: 1.25, vsBudget: 4.0 },
        { name: { pt: 'Deslocações e Estadas', en: 'Travel & Accommodation' }, value: 0.9, prevYear: 0.7, budget: 0.88, vsBudget: 2.3 },
        { name: { pt: 'Conservação e Reparação', en: 'Maintenance & Repairs' }, value: 1.0, prevYear: 0.8, budget: 0.98, vsBudget: 2.0 },
        { name: { pt: 'Limpeza, Higiene e Conforto', en: 'Cleaning & Hygiene' }, value: 0.5, prevYear: 0.4, budget: 0.48, vsBudget: 4.2 },
        { name: { pt: 'Serviços Aduaneiros', en: 'Customs Services' }, value: 0.5, prevYear: 0.4, budget: 0.49, vsBudget: 2.0 },
      ]
    },
    securityInsurance: {
      total: 5.4,
      prevYear: 4.2,
      yoyChange: 28.6,
      budgetTotal: 5.2,
      vsBudget: 3.8,
      items: [
        { name: { pt: 'Vigilância e Segurança', en: 'Security & Surveillance' }, value: 2.3, prevYear: 1.8, budget: 2.22, vsBudget: 3.6 },
        { name: { pt: 'Seguros', en: 'Insurance' }, value: 1.5, prevYear: 1.2, budget: 1.45, vsBudget: 3.4 },
        { name: { pt: 'Material de Protecção e Segurança', en: 'Safety & Protection Equipment' }, value: 0.6, prevYear: 0.5, budget: 0.58, vsBudget: 3.4 },
        { name: { pt: 'Quotizações (ANPID)', en: 'Memberships (ANPID)' }, value: 0.4, prevYear: 0.3, budget: 0.38, vsBudget: 5.3 },
        { name: { pt: 'Estudos Ambientais', en: 'Environmental Studies' }, value: 0.6, prevYear: 0.4, budget: 0.57, vsBudget: 5.3 },
      ]
    },
    itCommunication: {
      total: 4.5,
      prevYear: 3.5,
      yoyChange: 28.6,
      budgetTotal: 4.3,
      vsBudget: 4.7,
      items: [
        { name: { pt: 'Licenças Informáticas', en: 'Software Licenses' }, value: 1.0, prevYear: 0.8, budget: 0.95, vsBudget: 5.3 },
        { name: { pt: 'Serviços Informáticos', en: 'IT Services' }, value: 0.7, prevYear: 0.5, budget: 0.67, vsBudget: 4.5 },
        { name: { pt: 'Suporte ERP e Aplicações', en: 'ERP & Apps Support' }, value: 0.7, prevYear: 0.5, budget: 0.68, vsBudget: 2.9 },
        { name: { pt: 'Managed Print Services', en: 'Managed Print Services' }, value: 0.3, prevYear: 0.2, budget: 0.29, vsBudget: 3.4 },
        { name: { pt: 'Cibersegurança/NIS2', en: 'Cybersecurity/NIS2' }, value: 0.6, prevYear: 0.4, budget: 0.55, vsBudget: 9.1 },
        { name: { pt: 'Comunicações', en: 'Communications' }, value: 0.5, prevYear: 0.5, budget: 0.48, vsBudget: 4.2 },
        { name: { pt: 'Publicidade e Propaganda', en: 'Advertising' }, value: 0.4, prevYear: 0.3, budget: 0.39, vsBudget: 2.6 },
        { name: { pt: 'IT - Consultoria e Compliance', en: 'IT - Consulting & Compliance' }, value: 0.3, prevYear: 0.3, budget: 0.29, vsBudget: 3.4 },
      ]
    },
  },
  2026: {
    total: 34.0,
    prevYearTotal: 35.6,
    yoyChange: -4.5,
    supportServices: {
      total: 11.8,
      prevYear: 12.5,
      yoyChange: -5.6,
      items: [
        { name: { pt: 'Contencioso e Notariado', en: 'Litigation & Notary' }, value: 1.0, prevYear: 1.1 },
        { name: { pt: 'Assistência Técnica', en: 'Technical Assistance' }, value: 1.7, prevYear: 1.8 },
        { name: { pt: 'Avaliação de Diamantes', en: 'Diamond Valuation' }, value: 1.4, prevYear: 1.5 },
        { name: { pt: 'Serviços Técnicos de Engenharia', en: 'Engineering Technical Services' }, value: 1.9, prevYear: 2.0 },
        { name: { pt: 'Auditoria / Consultoria', en: 'Audit / Consulting' }, value: 1.4, prevYear: 1.5 },
        { name: { pt: 'Consultoria Fiscal', en: 'Tax Advisory' }, value: 0.95, prevYear: 1.0 },
        { name: { pt: 'Análises Laboratoriais/Estudos', en: 'Lab Analysis/Studies' }, value: 1.1, prevYear: 1.2 },
        { name: { pt: 'Serviços Jurídicos', en: 'Legal Services' }, value: 1.1, prevYear: 1.2 },
        { name: { pt: 'Honorários e Avenças', en: 'Fees & Retainers' }, value: 0.65, prevYear: 0.6 },
        { name: { pt: 'Planeamento e Optimização de Mina', en: 'Mine Planning & Optimization' }, value: 0.6, prevYear: 0.6 },
      ]
    },
    structureCosts: {
      total: 12.5,
      prevYear: 13.2,
      yoyChange: -5.3,
      items: [
        { name: { pt: 'Água', en: 'Water' }, value: 0.35, prevYear: 0.4 },
        { name: { pt: 'Electricidade', en: 'Electricity' }, value: 0.95, prevYear: 1.0 },
        { name: { pt: 'Combustíveis e Lubrificantes', en: 'Fuels & Lubricants' }, value: 2.2, prevYear: 2.3 },
        { name: { pt: 'Material Conservação e Reparação', en: 'Maintenance Materials' }, value: 1.4, prevYear: 1.5 },
        { name: { pt: 'Ferramentas e Utensílios', en: 'Tools & Utensils' }, value: 0.75, prevYear: 0.8 },
        { name: { pt: 'Material de Escritório', en: 'Office Supplies' }, value: 0.25, prevYear: 0.3 },
        { name: { pt: 'Rendas de Imóveis', en: 'Property Rentals' }, value: 1.8, prevYear: 1.9 },
        { name: { pt: 'Aluguer de Equipamento', en: 'Equipment Rental' }, value: 0.95, prevYear: 1.0 },
        { name: { pt: 'Transportes', en: 'Transportation' }, value: 1.2, prevYear: 1.3 },
        { name: { pt: 'Deslocações e Estadas', en: 'Travel & Accommodation' }, value: 0.85, prevYear: 0.9 },
        { name: { pt: 'Conservação e Reparação', en: 'Maintenance & Repairs' }, value: 0.95, prevYear: 1.0 },
        { name: { pt: 'Limpeza, Higiene e Conforto', en: 'Cleaning & Hygiene' }, value: 0.45, prevYear: 0.5 },
        { name: { pt: 'Serviços Aduaneiros', en: 'Customs Services' }, value: 0.45, prevYear: 0.5 },
      ]
    },
    securityInsurance: {
      total: 5.2,
      prevYear: 5.4,
      yoyChange: -3.7,
      items: [
        { name: { pt: 'Vigilância e Segurança', en: 'Security & Surveillance' }, value: 2.2, prevYear: 2.3 },
        { name: { pt: 'Seguros', en: 'Insurance' }, value: 1.45, prevYear: 1.5 },
        { name: { pt: 'Material de Protecção e Segurança', en: 'Safety & Protection Equipment' }, value: 0.55, prevYear: 0.6 },
        { name: { pt: 'Quotizações (ANPID)', en: 'Memberships (ANPID)' }, value: 0.4, prevYear: 0.4 },
        { name: { pt: 'Estudos Ambientais', en: 'Environmental Studies' }, value: 0.55, prevYear: 0.6 },
      ]
    },
    itCommunication: {
      total: 4.5,
      prevYear: 4.5,
      yoyChange: 0,
      items: [
        { name: { pt: 'Licenças Informáticas', en: 'Software Licenses' }, value: 1.0, prevYear: 1.0 },
        { name: { pt: 'Serviços Informáticos', en: 'IT Services' }, value: 0.7, prevYear: 0.7 },
        { name: { pt: 'Suporte ERP e Aplicações', en: 'ERP & Apps Support' }, value: 0.7, prevYear: 0.7 },
        { name: { pt: 'Managed Print Services', en: 'Managed Print Services' }, value: 0.3, prevYear: 0.3 },
        { name: { pt: 'Cibersegurança/NIS2', en: 'Cybersecurity/NIS2' }, value: 0.6, prevYear: 0.6 },
        { name: { pt: 'Comunicações', en: 'Communications' }, value: 0.5, prevYear: 0.5 },
        { name: { pt: 'Publicidade e Propaganda', en: 'Advertising' }, value: 0.4, prevYear: 0.4 },
        { name: { pt: 'IT - Consultoria e Compliance', en: 'IT - Consulting & Compliance' }, value: 0.3, prevYear: 0.3 },
      ]
    },
  },
};
